import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import venomContext from "./venomContext";

export default function VenomState(props) {
  // const BASE_URL = "http://localhost:3100";
  const BASE_URL = "https://venom-server.vercel.app";
  // const authToken = "authToken";
  const authToken = "token";
  const navigate = useNavigate();
  const [usersTotal, setUsersTotal] = useState([]);
  const [currentUser, setCurrentUser] = useState([]);
  const [categories, setCategories] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [currentUserBlogs, setCurrentUserBlogs] = useState([]);
  const [blogsCatWise, setBlogsCatWise] = useState([]);
  const [blogsAuthorWise, setBlogsAuthorWise] = useState([]);
  const [blogIDWise, setBlogIDWise] = useState([]);
  // Create Account
  const CreateAccount = async (email, profile) => {
    const url = BASE_URL + "/api/v1/user/create";
    document.querySelector(".loading").classList.remove("d-none");
    const data = await fetch(url, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, profile }),
    });
    const res = await data.json();
    console.log(res);
    document.querySelector(".loading").classList.add("d-none");
    if (res.success === true) {
      navigate("/login");
      toast.success(res.message, {
        position: "bottom-right",
      });
      return;
    }
    toast.warn(res.message, {
      position: "bottom-right",
    });
  };
  // Create User - Admin
  const createUserByAdmin = async (email, profile, role) => {
    const url = BASE_URL + "/api/v1/admin/user/create";
    document.querySelector(".loading").classList.remove("d-none");
    const data = await fetch(url, {
      method: "POST",
      headers: {
        authToken: localStorage.getItem(authToken),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, profile, role }),
    });
    const res = await data.json();
    console.log(res);
    document.querySelector(".loading").classList.add("d-none");
    if (res.success === true) {
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
  };
  //   User Login
  const userLogin = async (email, password) => {
    const url = BASE_URL + "/api/v1/user/login";
    document.querySelector(".loading").classList.remove("d-none");
    const data = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    const res = await data.json();
    document.querySelector(".loading").classList.add("d-none");
    if (res.success === true) {
      localStorage.setItem(authToken, res.authToken);
      toast.success("Logged in successfully", {
        position: "bottom-right",
      });
      navigate("/dash/all");
      return;
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
  };
  // Logged in User Details
  const loggedInUser = async () => {
    try {
      let url = BASE_URL + "/api/v1/user/details";
      // document.querySelector(".loading").classList.remove("d-none");
      let data = await fetch(url, {
        method: "GET",
        headers: {
          authToken: localStorage.getItem(authToken),
          "Content-Type": "application/json",
        },
      });
      let res = await data.json();
      // document.querySelector(".loading").classList.add("d-none");
      setCurrentUser(res ? res.user : []);
    } catch (error) {
      console.log(error);
    }
  };
  // Get All Users
  const getTotalUsers = async () => {
    const url = BASE_URL + "/api/v1/admin/users/details";
    const data = await fetch(url, {
      method: "GET",
      headers: {
        authToken: localStorage.getItem(authToken),
        "content-type": "application/json",
      },
    });
    const res = await data.json();
    setUsersTotal(res);
  };
  // Update User Profile
  const updateUserProfile = async (id, name, password, profile) => {
    const url = BASE_URL + "/api/v1/user/update/" + id;
    const data = await fetch(url, {
      method: "PUT",
      headers: {
        authToken: localStorage.getItem(authToken),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, password, profile }),
    });
    const res = await data.json();
    if (res.success === true) {
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
  };
  // Update User Info - admin
  const updateUserInfo = async (id, name, role, profile) => {
    const url = BASE_URL + "/api/v1/admin/user/update/" + id;
    const data = await fetch(url, {
      method: "PUT",
      headers: {
        authToken: localStorage.getItem(authToken),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, role, profile }),
    });
    const res = await data.json();
    if (res.success === true) {
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
  };
  // Logout
  const Logout = async () => {
    const url = BASE_URL + "/api/v1/user/logout";
    const data = await fetch(url, {
      method: "GET",
      headers: {
        authToken: localStorage.getItem(authToken),
        "Content-Type": "application/json",
      },
    });
    const res = await data.json();
    console.log(res);
    if (res.success === true) {
      localStorage.removeItem(authToken);
      toast.success("Logged out successfully", {
        position: "bottom-right",
      });
      return navigate("/");
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
    navigate("/");
  };
  const ResetPass = async (email, password) => {
    const url = BASE_URL + "/api/v1/reset/pass";
    document.querySelector(".loading").classList.remove("d-none");
    const data = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    const res = await data.json();
    console.log(res);
    document.querySelector(".loading").classList.add("d-none");
    if (res.success === false) {
      toast.error(res.message, {
        position: "bottom-right",
      });
      return;
    }
    toast.success(res.message, {
      position: "bottom-right",
    });
    navigate("/login");
  };
  // Create Category - Admin
  const createCategory = async (cat_name) => {
    const url = BASE_URL + "/api/v1/admin/create/category";
    document.querySelector(".loading").classList.remove("d-none");
    document.querySelector(".upload-wrapper").style.display = "flex";
    const data = await fetch(url, {
      method: "POST",
      headers: {
        authToken: localStorage.getItem(authToken),
        "content-type": "application/json",
      },
      body: JSON.stringify({ cat_name }),
    });
    const res = await data.json();
    document.querySelector(".loading").classList.add("d-none");
    document.querySelector(".upload-wrapper").style.display = "none";
    if (res.success === true) {
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.warn(res.message, {
      position: "bottom-right",
    });
  };
  //   Get all Categories
  const allCategories = async () => {
    const url = BASE_URL + "/api/v1/categories/all";
    const data = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const res = await data.json();
    const a = [];
    a.push(res);
    const b = { ...a };
    setCategories(b[0]);
  };
  // Delete Specific Category - Admin
  const deleteCategory = async (id) => {
    const url = BASE_URL + "/api/v1/admin/category/delete/" + id;
    const data = await fetch(url, {
      method: "DELETE",
      headers: {
        authToken: localStorage.getItem(authToken),
        "Content-Type": "application/json",
      },
    });
    const res = await data.json();
    if (res.success === true) {
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.warn(res.message, {
      position: "bottom-right",
    });
  };
  // Create Blog - Admin
  const createBlog = async (title, category, blogFeatureImg, longDesc) => {
    const url = BASE_URL + "/api/v1/user/blog/create";
    document.querySelector(".upload-wrapper").style.display = "flex";
    const data = await fetch(url, {
      method: "POST",
      headers: {
        authToken: localStorage.getItem(authToken),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title,
        category,
        description: longDesc,
        blog_feature_img: blogFeatureImg,
      }),
    });
    const res = await data.json();
    document.querySelector(".upload-wrapper").style.display = "none";
    if (res.success === true) {
      toast.success(res.message, {
        position: "bottom-right",
      });
      return;
    }
    toast.warn(res.message, {
      position: "bottom-right",
    });
  };
  //   Get all Blogs
  const allBlogs = async () => {
    const url = BASE_URL + "/api/v1/blogs/all";
    const data = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const res = await data.json();
    const a = [];
    a.push(res);
    const b = { ...a };
    setBlogs(b[0]);
  };
  //   Get Specific Blog
  const GetSpecificBlog = async (id) => {
    const url = BASE_URL + "/api/v1/blog/" + id;
    const data = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const res = await data.json();
    const a = [];
    a.push(res.blogs);
    const b = { ...a };
    setBlogIDWise(b[0]);
  };
  // Get Current User Blogs
  const getCurrentUserBlogs = async () => {
    const url = BASE_URL + "/api/v1/user/current/blogs/all";
    const data = await fetch(url, {
      method: "GET",
      headers: {
        authToken: localStorage.getItem(authToken),
        "content-type": "application/json",
      },
    });
    const res = await data.json();
    setCurrentUserBlogs(res.currentUserAllBlogs);
  };
  //   Get all Blogs - Categories wise
  const allBlogsCatWise = async (cat_name) => {
    const url = BASE_URL + "/api/v1/blogs/category/" + cat_name;
    const data = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const res = await data.json();
    const a = [];
    a.push(res);
    const b = { ...a };
    setBlogsCatWise(b[0]);
  };
  //   Get all Blogs - Author wise
  const allBlogsAuthorWise = async (author_name) => {
    const url = BASE_URL + "/api/v1/blogs/author/" + author_name;
    const data = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const res = await data.json();
    const a = [];
    a.push(res);
    const b = { ...a };
    setBlogsAuthorWise(b[0]);
  };
  // Update Blog
  const updateBlog = async (
    title,
    description,
    blog_feature_img,
    category,
    id
  ) => {
    const url = BASE_URL + "/api/v1/update/blog/" + id;
    document.querySelector(".upload-wrapper").style.display = "flex";
    document.querySelector(".loading").classList.remove("d-none");
    const data = await fetch(url, {
      method: "PUT",
      headers: {
        authToken: localStorage.getItem(authToken),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ title, description, blog_feature_img, category }),
    });
    const res = await data.json();
    console.log(res);
    document.querySelector(".upload-wrapper").style.display = "none";
    document.querySelector(".loading").classList.add("d-none");
    if (res.success === true) {
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
  };
  // Delete Blog - Logged In User
  const deleteBlog = async (id) => {
    const url = BASE_URL + "/api/v1/delete/blog/" + id;
    const data = await fetch(url, {
      method: "DELETE",
      headers: {
        authToken: localStorage.getItem(authToken),
        "content-type": "application/json",
      },
    });
    const res = await data.json();
    console.log(res);
    if (res.success === true) {
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
  };
  // Delete Logged In User
  const deleteLoggedUser = async (id) => {
    const url = BASE_URL + "/api/v1/user/delete/" + id;
    const data = await fetch(url, {
      method: "DELETE",
      headers: {
        authToken: localStorage.getItem(authToken),
        "Content-Type": "application/json",
      },
    });
    const res = await data.json();
    console.log(res);
    if (res.success === true) {
      localStorage.removeItem(authToken);
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
  };
  // Delete User- admin
  const deleteUserByAdmin = async (id) => {
    const url = BASE_URL + "/api/v1/admin/user/delete/" + id;
    const data = await fetch(url, {
      method: "DELETE",
      headers: {
        authToken: localStorage.getItem(authToken),
        "content-type": "application/json",
      },
    });
    const res = await data.json();
    console.log(res);
    if (res.success === true) {
      // localStorage.removeItem("authToken");
      return toast.success(res.message, {
        position: "bottom-right",
      });
    }
    toast.error(res.message, {
      position: "bottom-right",
    });
  };
  return (
    <venomContext.Provider
      value={{
        CreateAccount,
        userLogin,
        loggedInUser,
        currentUser,
        getTotalUsers,
        usersTotal,
        updateUserProfile,
        updateUserInfo,
        Logout,
        ResetPass,
        createCategory,
        allCategories,
        categories,
        deleteCategory,
        createBlog,
        allBlogs,
        blogs,
        GetSpecificBlog,
        getCurrentUserBlogs,
        currentUserBlogs,
        blogIDWise,
        allBlogsCatWise,
        blogsCatWise,
        allBlogsAuthorWise,
        blogsAuthorWise,
        updateBlog,
        deleteBlog,
        createUserByAdmin,
        deleteLoggedUser,
        deleteUserByAdmin,
      }}
    >
      {props.children}
    </venomContext.Provider>
  );
}
